import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogBackdrop,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogCloseButton,
  AlertDialogBody,
  AlertDialogFooter,
} from '~/components/gluestack/alert-dialog';
import { Button, ButtonText, ButtonIcon } from '~/components/gluestack/button';
import { Text } from '~/components/gluestack/text';
import { Heading } from '~/components/gluestack/heading';
import { Input, InputField } from '~/components/gluestack/input';
import { HugeIconsWrapper } from './HugeIconsWrapper';
import { Cancel01Icon } from '@hugeicons-pro/core-solid-rounded';
import { CopyIcon, LinkIcon } from '~/components/gluestack/icon';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  shareUrl: string;
  onCopyUrl: () => void;
  onOpenUrl: () => void;
  title?: string;
}

export function ShareModal({ 
  isOpen, 
  onClose, 
  shareUrl, 
  onCopyUrl, 
  onOpenUrl,
  title 
}: ShareModalProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} size="md">
      <AlertDialogBackdrop />
      <AlertDialogContent>
        <AlertDialogHeader>
          <Heading size="md">{title || t('common.share.shareLink')}</Heading>
          <AlertDialogCloseButton>
            <HugeIconsWrapper icon={Cancel01Icon} size={20} className="color-neutral-500" />
          </AlertDialogCloseButton>
        </AlertDialogHeader>
        <AlertDialogBody className="mt-3">
          <Text className="mb-2">{t('common.share.url')}:</Text>
          <Input>
            <InputField value={shareUrl} readOnly={true} className="py-3" />
          </Input>
        </AlertDialogBody>
        <AlertDialogFooter className="mt-4 gap-3">
          <Button variant="solid" action="primary" onPress={onCopyUrl} size="sm">
            <ButtonIcon as={CopyIcon} color="white" />
            <ButtonText>{t('common.share.copy')}</ButtonText>
          </Button>
          <Button variant="outline" action="neutral" onPress={onOpenUrl} size="sm">
            <ButtonIcon as={LinkIcon} />
            <ButtonText>{t('common.share.open')}</ButtonText>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
} 